import { useEffect, useState } from "react";

// Де зараз на екрані елемент за селектором (null — немає або схований). Перемірює при скролі, ресайзі
// і раз на 300 мс: меню на телефоні виїжджає з анімацією, блоки головної довантажуються.
export const useTargetRect = (selector, active = true) => {
  const [rect, setRect] = useState(null);

  useEffect(() => {
    if (!active || !selector) {
      setRect(null);
      return;
    }
    const measure = () => {
      const element = document.querySelector(selector);
      const box = element?.getBoundingClientRect();
      const visible = box && box.width > 0 && box.height > 0 && box.right > 0 && box.left < window.innerWidth;
      setRect((prev) => {
        if (!visible) return null;
        const next = { top: box.top, left: box.left, width: box.width, height: box.height };
        const same = prev && ["top", "left", "width", "height"].every((key) => Math.abs(prev[key] - next[key]) < 0.5);
        return same ? prev : next;
      });
    };
    measure();
    const timer = setInterval(measure, 300);
    window.addEventListener("resize", measure);
    window.addEventListener("scroll", measure, true);
    return () => {
      clearInterval(timer);
      window.removeEventListener("resize", measure);
      window.removeEventListener("scroll", measure, true);
    };
  }, [selector, active]);

  return rect;
};

// Куди поставити картку поруч із елементом: праворуч (пункти меню на компʼютері), інакше під або над ним
export const placeCard = (rect, card = { width: 340, height: 230 }, gap = 14) => {
  const margin = 16;
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const width = Math.min(card.width, vw - margin * 2);
  const clampLeft = (left) => Math.max(margin, Math.min(left, vw - width - margin));
  const clampTop = (top) => Math.max(margin, Math.min(top, vh - card.height - margin));

  if (!rect) return { width, left: (vw - width) / 2, top: Math.max(margin, (vh - card.height) / 2), side: "center" };
  if (rect.left + rect.width + gap + width + margin <= vw) {
    return { width, left: rect.left + rect.width + gap, top: clampTop(rect.top + rect.height / 2 - card.height / 2), side: "right" };
  }
  if (rect.top + rect.height + gap + card.height + margin <= vh) {
    return { width, left: clampLeft(rect.left + rect.width / 2 - width / 2), top: rect.top + rect.height + gap, side: "bottom" };
  }
  if (rect.top - gap - card.height >= margin) {
    return { width, left: clampLeft(rect.left + rect.width / 2 - width / 2), top: rect.top - gap - card.height, side: "top" };
  }
  return { width, left: clampLeft(rect.left), top: vh - card.height - margin, side: "bottom" };
};
